import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "aa-error",
  templateUrl: "./error.component.html",
  host: { class: "anonymous-page" },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ErrorComponent {}
